// App.js
import React, { useEffect, useMemo, useState } from "react";
import "./App.css";

import Footer from "./Footer";

import { db } from "./firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
const DEFAULT_BANNER = "/images/banners/banner.png";
const PLACEHOLDER_IMG = "/images/placeholder.png";

/* ===========================================================
   🔧 دالة إصلاح مسار الصورة (النسخة الصحيحة)
   =========================================================== */
const toSrc = (path) => {
  if (!path) return "";

  // رابط خارجي https:// أو http://
  if (path.startsWith("https://") || path.startsWith("http://")) {
    return path;
  }

  // Base64
  if (path.startsWith("data:image")) return path;

  // يبدأ بـ /
  if (path.startsWith("/")) return path;

  // مسار داخل المشروع
  return `/${path}`;
};

/* ===========================================================
   🖼 كومبوننت سلايدر البانرات
=========================================================== */
function BannerSlider({ images, alt }) {
  const validImages = (images || []).filter(Boolean);
  const [index, setIndex] = useState(0);

  // 🔥 اليوزإفكت لازم يجي قبل أي return
  useEffect(() => {
    if (validImages.length === 0) return;

    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % validImages.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [validImages.length]);

  // دوال التنقل
  const next = () => {
    if (validImages.length === 0) return;
    setIndex((i) => (i + 1) % validImages.length);
  };

  const prev = () => {
    if (validImages.length === 0) return;
    setIndex((i) => (i - 1 + validImages.length) % validImages.length);
  };

  // 🔥 الآن return في النهاية فقط
  if (validImages.length === 0) return null;

  return (
    <div className="banner-slider">
      <button className="banner-arrow left" onClick={prev}>‹</button>
      <div className="banner-slide">
        <img src={toSrc(validImages[index])} alt={alt} />
      </div>
      <button className="banner-arrow right" onClick={next}>›</button>
    </div>
  );
}


/* ===========================================================
   🖼 كومبوننت الصور داخل كل منتج (سلايدر)
=========================================================== */
function ProductImages({ images }) {
  const valid = (images || []).filter(Boolean);
  const [idx, setIdx] = useState(0);

  if (!valid.length) return null;

  return (
    <div className="product-slider no-arrows">
      {/* صورة واحدة بدون أسهم */}
      <img src={toSrc(valid[idx])} alt="" />
    </div>
  );
}


/* ===========================================================
   📦 الصفحة الرئيسية (App)
=========================================================== */
function App() {
  const [language, setLanguage] = useState("ar"); // ar | en

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [modal, setModal] = useState(null);
const [hideHeader, setHideHeader] = useState(false);
const [lastScroll, setLastScroll] = useState(0);

useEffect(() => {
  function handleScroll() {
    const current = window.scrollY;

    if (current > lastScroll && current > 120) {
      setHideHeader(true); 
    } else {
      setHideHeader(false);
    }

    setLastScroll(current);
  }

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, [lastScroll]);

  const t = {
    ar: {
      price: "السعر",
      calories: "سعرات",
      sar: "ر.س",
      menu: "المنيو",
    },
    en: {
      price: "Price",
      calories: "Calories",
      sar: "SAR",
      menu: "Menu",
    },
  }[language];

  const toggleLang = () => {
    setLanguage((prev) => (prev === "ar" ? "en" : "ar"));
  };

  /* ===========================================================
     🔥 تحميل الأقسام + المنتجات
  ============================================================ */
  async function loadMenu() {
    setLoading(true);
    try {
      const qCats = query(
        collection(db, "menuCategories"),
        orderBy("order", "asc")
      );
      const snap = await getDocs(qCats);

      const cats = await Promise.all(
        snap.docs.map(async (d) => {
          const data = d.data();
          const catId = d.id;

          const qItems = query(
            collection(db, "menuCategories", catId, "items"),
            orderBy("order", "asc")
          );
          const itemsSnap = await getDocs(qItems);
          const items = itemsSnap.docs
            .map((i) => ({
              id: i.id,
              ...i.data(),
            }))
            .filter((i) => !i.hidden);

          return {
            id: catId,
            ...data,
            items,
          };
        })
      );

      setCategories(cats.filter((c) => !c.hidden));
    } catch (err) {
      console.error("loadMenu error:", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadMenu();
  }, []);

  /* ===========================================================
     🖼 نافذة التفاصيل
  ============================================================ */
  function Modal({ item, onClose }) {
    if (!item) return null;

    return (
      <div className="modal-backdrop" onClick={onClose}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <button className="modal-close" onClick={onClose}>
              ×
            </button>
          </div>

          <div className="modal-body">
            <div className="modal-media">
              <img src={toSrc(item.itemImages?.[0] || item.img)} alt="" />
            </div>

            <div className="modal-info">
              
              <h2 className="modal-title">

                {language === "ar" ? item.name : item.name_en || item.name}

              </h2>

              <div className="modal-price">
                {item.price} {t.sar}
              </div>

              {item.calories && (
                <div className="modal-meta">
                  {t.calories}: <span>{item.calories}</span>
                </div>
              )}

              {item.desc && (
                <div className="modal-desc">
                  {language === "ar" ? item.desc : item.desc_en || item.desc}
                </div>
                
              )}
              {/* خيارات العجينة في الكرت */}
{/* أنواع العجينة */}
{item.flourTypes?.length > 0 && (
  <div className="flour-type">
    <b>العجينة المتوفرة:</b>
    <div>{item.flourTypes.join(" / ")}</div>
  </div>
)}

{/* الإضافات */}
{item.extras?.length > 0 && (
  <div className="modal-extras">
    <b>الإضافات المتاحة:</b>
    {item.extras.map((ex, i) => (
      <div key={i} className="extra-item">
        <span>{ex.name}</span>
        <span>{ex.price} ر.س</span>
      </div>
    ))}
  </div>
)}




            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ===========================================================
     🎨 واجهة المنيو
  ============================================================ */
  return (
    <div className="page" dir={language === "ar" ? "rtl" : "ltr"}>
      {/* الهيدر */}
     <header className={`topbar ${hideHeader ? "hide-header" : ""}`}>

  {/* القسم الأعلى من الهيدر (اللوقو + اللغة) */}
  <div className="header-content container">
    <div className="logo-title">
      <img src="/images/logo4.png" className="logo" alt="logo" />

      <div>
        <h1 className="brand">الفطيرة الدمشقية</h1>
        <h5 className="brand-sub">مرحبا بكم في الفطيرة الدمشقية</h5>
      </div>
    </div>

    <button className="lang-switch" onClick={toggleLang}>
      {language === "ar" ? "English" : "العربية"}
    </button>
  </div>

  {/* شريط الأقسام المدمج داخل الهيدر */}
  <nav className="header-cats hide-scrollbar">
    <ul className="header-cats-list container">
      {categories.map((c) => (
        <li key={c.id}>
          <a href={`#${c.id}`} className="cat-pill">
            {language === "ar" ? c.title : c.title_en || c.title}
          </a>
        </li>
      ))}
    </ul>
  </nav>

</header>


     

      {/* الأقسام */}
      <main className="main container">
        {loading && <div className="muted">جارِ التحميل...</div>}

        {!loading &&
          categories.map((cat) => (
            <section id={cat.id} key={cat.id} className="section">
              {/* بانرات أعلى القسم */}
              {cat.bannerTopImages?.length > 0 && (
                <BannerSlider images={cat.bannerTopImages} alt={cat.title} />
              )}

              <h2 className="section-title">
                {language === "ar" ? cat.title : cat.title_en || cat.title}
              </h2>

             <div className="grid">
  {cat.items.map((item) => (
    <div
      key={item.id}
      className="card"
      onClick={() => setModal(item)}
    >
      <div className="thumb">
        <ProductImages
          images={item.itemImages?.length ? item.itemImages : [item.img]}
        />
      </div>

     <div className="info">
  <h3 className="title">
    {language === "ar" ? item.name : item.name_en || item.name}
  </h3>

  {/* السعر */}
  <div className="price">
    {item.price} {t.sar}
  </div>

  {/* السعرات */}
  {item.calories && (
    <div className="calories">
      {item.calories} سُعره
    </div>
  )}

  {/* العجينة */}
  {item.flourTypes?.length > 0 && (
    <div className="flour-type-card">
      عجينة: {item.flourTypes.join(" / ")}
    </div>
  )}
</div>


        {/* عرض العجينة فقط داخل البطاقة */}
        {item.flourTypes?.length > 0 && (
          <div className="card-flour">
            عجينة: {item.flourTypes.join(" / ")}
          </div>
        )}
      </div>
    
  ))}
</div>



              {/* بانرات بعد القسم */}
              {cat.bannerAfterImages?.length > 0 && (
                <BannerSlider images={cat.bannerAfterImages} alt={cat.title} />
              )}

              
            </section>
          ))}
          
      </main>

      

          {/* نافذة التفاصيل */}
      {modal && <Modal item={modal} onClose={() => setModal(null)} />}

      <Footer />

    </div>
  );

}


export default App;

// App.js
// import React, { useEffect, useMemo, useState } from "react";
// import "./App.css";

// import Footer from "./Footer";

// import { db } from "./firebase";
// import { collection, getDocs, query, orderBy } from "firebase/firestore";
// const DEFAULT_BANNER = "/images/banners/banner.png";
// const PLACEHOLDER_IMG = "/images/placeholder.png";

// /* ===========================================================
//    🔧 دالة إصلاح مسار الصورة (النسخة الصحيحة)
//    =========================================================== */
// const toSrc = (path) => {
//   if (!path) return "";

//   // رابط خارجي https:// أو http://
//   if (path.startsWith("https://") || path.startsWith("http://")) {
//     return path;
//   }

//   // Base64
//   if (path.startsWith("data:image")) return path;

//   // يبدأ بـ /
//   if (path.startsWith("/")) return path;

//   // مسار داخل المشروع
//   return `/${path}`;
// };

// /* ===========================================================
//    🖼 كومبوننت سلايدر البانرات
// =========================================================== */
// function BannerSlider({ images, alt }) {
//   const validImages = (images || []).filter(Boolean);
//   const [index, setIndex] = useState(0);

//   // 🔥 اليوزإفكت لازم يجي قبل أي return
//   useEffect(() => {
//     if (validImages.length === 0) return;

//     const interval = setInterval(() => {
//       setIndex((i) => (i + 1) % validImages.length);
//     }, 3500);

//     return () => clearInterval(interval);
//   }, [validImages.length]);

//   // دوال التنقل
//   const next = () => {
//     if (validImages.length === 0) return;
//     setIndex((i) => (i + 1) % validImages.length);
//   };

//   const prev = () => {
//     if (validImages.length === 0) return;
//     setIndex((i) => (i - 1 + validImages.length) % validImages.length);
//   };

//   // 🔥 الآن return في النهاية فقط
//   if (validImages.length === 0) return null;

//   return (
//     <div className="banner-slider">
//       <button className="banner-arrow left" onClick={prev}>‹</button>
//       <div className="banner-slide">
//         <img src={toSrc(validImages[index])} alt={alt} />
//       </div>
//       <button className="banner-arrow right" onClick={next}>›</button>
//     </div>
//   );
// }


// /* ===========================================================
//    🖼 كومبوننت الصور داخل كل منتج (سلايدر)
// =========================================================== */
// function ProductImages({ images }) {
//   const valid = (images || []).filter(Boolean);
//   const [idx, setIdx] = useState(0);

//   if (!valid.length) return null;

//   return (
//     <div className="product-slider no-arrows">
//       {/* صورة واحدة بدون أسهم */}
//       <img src={toSrc(valid[idx])} alt="" />
//     </div>
//   );
// }


// /* ===========================================================
//    📦 الصفحة الرئيسية (App)
// =========================================================== */
// function App() {
//   const [language, setLanguage] = useState("ar"); // ar | en

//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [modal, setModal] = useState(null);
// const [hideHeader, setHideHeader] = useState(false);
// const [lastScroll, setLastScroll] = useState(0);

// useEffect(() => {
//   function handleScroll() {
//     const current = window.scrollY;

//     if (current > lastScroll && current > 120) {
//       setHideHeader(true); 
//     } else {
//       setHideHeader(false);
//     }

//     setLastScroll(current);
//   }

//   window.addEventListener("scroll", handleScroll);
//   return () => window.removeEventListener("scroll", handleScroll);
// }, [lastScroll]);

//   const t = {
//     ar: {
//       price: "السعر",
//       calories: "سعرات",
//       sar: "ر.س",
//       menu: "المنيو",
//     },
//     en: {
//       price: "Price",
//       calories: "Calories",
//       sar: "SAR",
//       menu: "Menu",
//     },
//   }[language];

//   const toggleLang = () => {
//     setLanguage((prev) => (prev === "ar" ? "en" : "ar"));
//   };

//   /* ===========================================================
//      🔥 تحميل الأقسام + المنتجات
//   ============================================================ */
//   async function loadMenu() {
//     setLoading(true);
//     try {
//       const qCats = query(
//         collection(db, "menuCategories"),
//         orderBy("order", "asc")
//       );
//       const snap = await getDocs(qCats);

//       const cats = await Promise.all(
//         snap.docs.map(async (d) => {
//           const data = d.data();
//           const catId = d.id;

//           const qItems = query(
//             collection(db, "menuCategories", catId, "items"),
//             orderBy("order", "asc")
//           );
//           const itemsSnap = await getDocs(qItems);
//           const items = itemsSnap.docs
//             .map((i) => ({
//               id: i.id,
//               ...i.data(),
//             }))
//             .filter((i) => !i.hidden);

//           return {
//             id: catId,
//             ...data,
//             items,
//           };
//         })
//       );

//       setCategories(cats.filter((c) => !c.hidden));
//     } catch (err) {
//       console.error("loadMenu error:", err);
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     loadMenu();
//   }, []);

//   /* ===========================================================
//      🖼 نافذة التفاصيل
//   ============================================================ */
//   function Modal({ item, onClose }) {
//     if (!item) return null;

//     return (
//       <div className="modal-backdrop" onClick={onClose}>
//         <div className="modal" onClick={(e) => e.stopPropagation()}>
//           <div className="modal-header">
//             <button className="modal-close" onClick={onClose}>
//               ×
//             </button>
//           </div>

//           <div className="modal-body">
//             <div className="modal-media">
//               <img src={toSrc(item.itemImages?.[0] || item.img)} alt="" />
//             </div>

//             <div className="modal-info">
//               <h2 className="modal-title">
//                 {language === "ar" ? item.name : item.name_en || item.name}
//               </h2>

//               <div className="modal-price">
//                 {item.price} {t.sar}
//               </div>

//               {item.calories && (
//                 <div className="modal-meta">
//                   {t.calories}: <span>{item.calories}</span>
//                 </div>
//               )}

//               {item.desc && (
//                 <div className="modal-desc">
//                   {language === "ar" ? item.desc : item.desc_en || item.desc}
//                 </div>
                
//               )}
//               {/* خيارات العجينة  </span>
//   </div>
// )}

// {/* الإضافات في الكرت */}
// {item.extras?.length > 0 && (
//   <div className="small-options">
//     {item.extras.map((op, i) => (
//       <span key={i} className="option-chip">
//         {op.name} — {op.price} ر.س
//       </span>
//     ))}
//   </div>
// )}


// {item.options?.length > 0 && (
//   <div className="small-options">
//     {item.options.map((op, i) => (
//       <span key={i} className="option-chip">{op}</span>
//     ))}
//   </div>
// )}


//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   /* ===========================================================
//      🎨 واجهة المنيو
//   ============================================================ */
//   return (
//     <div className="page" dir={language === "ar" ? "rtl" : "ltr"}>
//       {/* الهيدر */}
//      <header className={`topbar ${hideHeader ? "hide-header" : ""}`}>

//   {/* القسم الأعلى من الهيدر (اللوقو + اللغة) */}
//   <div className="header-content container">
//     <div className="logo-title">
//       <img src="/images/logo4.png" className="logo" alt="logo" />

//       <div>
//         <h1 className="brand">الفطيرة الدمشقية</h1>
//         <h5 className="brand-sub">مرحبا بكم في الفطيرة الدمشقية</h5>
//       </div>
//     </div>

//     <button className="lang-switch" onClick={toggleLang}>
//       {language === "ar" ? "English" : "العربية"}
//     </button>
//   </div>

//   {/* شريط الأقسام المدمج داخل الهيدر */}
//   <nav className="header-cats hide-scrollbar">
//     <ul className="header-cats-list container">
//       {categories.map((c) => (
//         <li key={c.id}>
//           <a href={`#${c.id}`} className="cat-pill">
//             {language === "ar" ? c.title : c.title_en || c.title}
//           </a>
//         </li>
//       ))}
//     </ul>
//   </nav>

// </header>


//       {/* شريط الأقسام */}
//       {/* <nav className="nav nav-scroll hide-scrollbar">
//         <ul className="nav-list container">
//           {categories.map((c) => (
//             <li key={c.id}>
//               <a href={`#${c.id}`} className="pill">
//                 {language === "ar" ? c.title : c.title_en || c.title}
//               </a>
//             </li>
//           ))}
//         </ul>
//       </nav> */}

//       {/* الأقسام */}
//       <main className="main container">
//         {loading && <div className="muted">جارِ التحميل...</div>}

//         {!loading &&
//           categories.map((cat) => (
//             <section id={cat.id} key={cat.id} className="section">
//               {/* بانرات أعلى القسم */}
//               {cat.bannerTopImages?.length > 0 && (
//                 <BannerSlider images={cat.bannerTopImages} alt={cat.title} />
//               )}

//               <h2 className="section-title">
//                 {language === "ar" ? cat.title : cat.title_en || cat.title}
//               </h2>

//               <div className="grid">
//                 {cat.items.map((item) => (
//                   <div
//                     key={item.id}
//                     className="card"
//                     onClick={() => setModal(item)}
//                   >
//                     <div className="thumb">
//                       <ProductImages
//                         images={item.itemImages?.length ? item.itemImages : [item.img]}
//                       />
//                     </div>

//                     <div className="info">
//                       <h3 className="title">
//                         {language === "ar" ? item.name : item.name_en || item.name}
//                       </h3>

//                       <div className="price">
//                         {item.price} {t.sar}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* بانرات بعد القسم */}
//               {cat.bannerAfterImages?.length > 0 && (
//                 <BannerSlider images={cat.bannerAfterImages} alt={cat.title} />
//               )}

              
//             </section>
//           ))}
          
//       </main>

      

//           {/* نافذة التفاصيل */}
//       {modal && <Modal item={modal} onClose={() => setModal(null)} />}

//       <Footer />

//     </div>
//   );

// }


// export default App;
